import { render, staticRenderFns } from "./initiateDetail.vue?vue&type=template&id=4ef33970&scoped=true"
import script from "./initiateDetail.vue?vue&type=script&lang=js"
export * from "./initiateDetail.vue?vue&type=script&lang=js"
import style0 from "./initiateDetail.vue?vue&type=style&index=0&id=4ef33970&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef33970",
  null
  
)

export default component.exports